export const isInCypress = () => {
  try {
    // @ts-expect-error - TS18047 - 'window.top' is possibly 'null'. | TS2339 - Property '__Cypress__' does not exist on type 'Window'.
    return Boolean(window.top.__Cypress__);
  } catch (e: any) {
    return false;
  }
};

/**
 * In CI, both Cypress and Jest use `NODE_ENV=test`, we also cannot reliably check JEST.WORKER_ID because it may not be set when running in band.
 *
 * Therefore, we check for the absence of Cypress to infer that `NODE_ENV=test` is Jest.
 */
export const isInJest =
  !isInCypress() &&
  (process.env.NODE_ENV === 'test' || process.env.JEST_WORKER_ID !== undefined);
